/**
 * uni.webview SDK（Webpack 走 module.exports，不会自动挂 window.uni）。
 * 使用 ensureUniWebview() 在需要时初始化；仅在疑似 uni-app web-view（UA 含 uni-app）时挂 window.uni。
 */
import uniModule from './uni.webview.1.5.5.js';

const uniObj = uniModule && uniModule.default !== undefined ? uniModule.default : uniModule;

function isLikelyUniAppWebView() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return false;
    }
    const userAgent = navigator.userAgent || '';
    if (/uni-app/i.test(userAgent)) {
        return true;
    }
    return !!window.uni;
}

/**
 * 同步判断：是否运行在 uni-app 的 web-view 内（依据 UA 含 `uni-app`，与官方 SDK 一致）。
 * 普通浏览器、纯微信 H5（非 uni-app 包）一般为 false。
 */
export function isUniAppWebViewEnv() {
    return isLikelyUniAppWebView();
}

/**
 * 异步：通过官方桥 getEnv 获取当前端类型（如 miniprogram / h5 / plus 等），比 UA 更细。
 * 需在能注入 wx.miniProgram 等环境时才有意义；失败返回 null。
 */
export function getUniWebviewRuntimeEnv() {
    const u = uniObj;
    return new Promise((resolve) => {
        if (!u) {
            resolve(null);
            return;
        }
        const pick = (o) => (o && typeof o.getEnv === 'function' ? o : null);
        const target = pick(u.webView) || pick(u);
        if (!target) {
            resolve(null);
            return;
        }
        try {
            target.getEnv((res) => {
                resolve(res && typeof res === 'object' ? res : null);
            });
        } catch (e) {
            resolve(null);
        }
    });
}

let installed = false;

/**
 * 初始化 uni webview 桥接（可重复调用，仅首次生效）。
 * @returns {object|undefined} 官方 SDK 返回的 uni 对象（含 webView、getEnv 等）
 */
export function ensureUniWebview() {
    if (!uniObj) return undefined;
    if (!installed) {
        installed = true;
        if (typeof window !== 'undefined' && isLikelyUniAppWebView()) {
            window.uni = uniObj;
        }
    }
    return uniObj;
}

export default uniObj;
export { uniObj as uni };
